import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { login, currentAccount, logout } from 'services/user-jwt'
import actions from './actions'

// login dispatcher
export function* LOGIN({ payload }) {
  console.log('user sagas.js LOGIN')
  const { phone, drcode } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const success = yield call(login, phone, drcode)
  console.log('user sagas.js LOGIN success', success)
  if (success) {
    notification.success({
      message: 'Logged In',
      description: '登入成功!',
    })
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
  } else {
    notification.success({
      message: 'Logged In',
      description: '登入失敗，請重試!',
    })
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const response = yield call(currentAccount)
  if (response) {
    const { userid, name, height, weight, drCode, token } = response
    yield put({
      type: 'user/SET_STATE',
      payload: {
        id: userid,
        name,
        height,
        weight,
        drCode,
        authorized: true,
        token,
      },
    })
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
}

export function* LOGOUT() {
  yield call(logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
